import http from '@/plugin/axios'
import Detail from '@utils/detail'
import HeadInfo from '@/components/common/head-info/head-info.vue'
import Options from '@utils/common/options'
import { $t } from '@/plugin/i18n'
import Table from '@utils/table'
import Jurisdiction from '@utils/jurisdiction'
import { tablePrint } from '@utils/index'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'

function print(this: any) {
  const purchaseNo = this.detialData && this.detialData.purchaseNo
  if (!purchaseNo) return
  tablePrint({
    url: '/srmPurchaseHead/printOrder',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo: purchaseNo }
  })
}

function confirmDisabled(selection: any[]) {
  if (!selection.length) return true
  const noStatus1 = selection.filter(item => !item || item.status !== '1')
  if (noStatus1.length) return 'ordersupplier.ordertrack.notStatus1'
  return false
}

async function batchConfirm(this: any) {
  await this.$confirm(this.$t('ordersupplier.ordertrack.confirmTip'))
  const purchaseNo = this.detialData && this.detialData.purchaseNo
  await http({
    url: '/srmPurchaseHead/confirmOrder',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo: purchaseNo }
  })
  this.refresh()
}

const jurisdiction = new Jurisdiction('ordersupplier.ordertrack')
  .add('confirm').icon('icon-querendingdan').disabled(confirmDisabled).handle(batchConfirm)
  .lib('print').handle(print)

async function getDetailData(data: any) {
  const info = { ... data.row }
  const headInfo = await http({
    url: '/srmPurchaseHead/getPurchaseHeadByNo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo: info.purchaseNo, status: info.status },
    loading: false
  })
  info.headInfo = Object.freeze(headInfo)
  return info
}

function getOption(key: string, data: any) {
  return $t(Options.lib.get(key).exec(data[key]))
}

const info = [
  {
    title: 'customerInformation',
    // width: '28%',
    list: [
      ['purOfficeName'],
      ['addressStr'],
      ['contacts'],
      ['contactPhone']
    ]
  },
  {
    title: 'documentInformation',
    // width: '28%',
    list: [
      ['orderType', (data: any) => getOption('orderType', data)],
      ['employeeName'],
      ['purchaseDate'],
      ['remarks'],
      ['dataSource', (data: any) => $t(Options.lib.get('dataSource1').exec(data['dataSource']))],
      ['outPurchaseNo']
    ]
  },
  {
    title: 'paymentInformation',
    // width: '40%',
    list: [
      ['taxInfo'],
      ['txTermsName'],
      ['payTermsName'],
      ['totalAmountPreTaxPur'],
      ['totalPurAmount'],
      ['totalTaxIncludedPur']
    ]
  }
]

const header = {
  props: ['data'],
  render(this: any, h: any) { return h('div', [`${this.$t('ordersupplier.ordertrack.purchaseNo')}: ${this.data.purchaseNo}`]) }
}

const table = new Table('ordersupplier.ordertrack')
  .type('index')
  .add('purchaseSeq')
  .add('purchasePhaseSeq')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('batchValuationQty')
  .add('unitPrice')
  .add('taxInfo').label('tableTaxInfo').width(190).tooltip()
  .add('taxTypeInfo')
  .add('shipmentQty')
  .add('receiveQty')
  .add('onWayQty')
  .add('refundQty')
  .add('returnExchangeQty')
  .add('undeliveredQty')
  .add('unReceiveQty')
  .add('expectedArrivalDate').date()
  .add('replyDeliveryNum')
  .add('statusName')
  .add('remarks')

const fileNoAttrs = {
  disabled: true,
  async parse(this: any) {
    const list = await http<any[]>({
      url: '/srmOrderFile/getSrmOrderFileList',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { docNo: this.value.purchaseNo }
    })
    return list.map(item => {
      return {
        name: item.fileName,
        url: '/srmOrderFile/downloadSrmOrderFile',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { fileId: item.fileId, purchaseNo: this.value.purchaseNo },
        fileId: item.fileId,
        docNo: item.docNo
      }
    })
  }
}

export default new Detail('ordersupplier.ordertrack')
  .dTitle(header)
  .getData(getDetailData)
  .url('/srmPurchaseSchedule/getSrmPurSchedulePage', process.env.VUE_APP_PURCHASE_API)
  .params(row => ({ status: row.status, purchaseNo: row.purchaseNo }))
  .title('headInfo')
  .add('headInfo').rowComponent(HeadInfo).bind('prefix', 'ordersupplier.ordertrack').bind('info', info)
  .add('headInfo').label('').component(UploadSelect).col(24).attrs(fileNoAttrs)
  .addGroup('purchaseDetail')
  .table('test', table)
  .jurisdiction(jurisdiction)
